import { render, staticRenderFns } from "./sort-product.vue?vue&type=template&id=31d6eaed&scoped=true&"
import script from "./sort-product.vue?vue&type=script&lang=js&"
export * from "./sort-product.vue?vue&type=script&lang=js&"
import style0 from "./sort-product.vue?vue&type=style&index=0&id=31d6eaed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d6eaed",
  null
  
)

export default component.exports